import { get } from 'lodash';
import { useAuth } from 'react-oidc-context';

export const useGetUserInfo = () => {
  const auth = useAuth();

  return {
    email: get(auth, 'user.profile.email'),
    avatar: get(auth, 'user.profile.picture'),
    first_name: get(auth, 'user.profile.given_name'),
    last_name: get(auth, 'user.profile.family_name'),
  };
};
